import { render, staticRenderFns } from "./DialogImport.vue?vue&type=template&id=3126615b&scoped=true&"
import script from "./DialogImport.vue?vue&type=script&lang=js&"
export * from "./DialogImport.vue?vue&type=script&lang=js&"
import style0 from "./DialogImport.vue?vue&type=style&index=0&id=3126615b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126615b",
  null
  
)

export default component.exports